<template>
  <div id="settings-wrapper">
    <h4>Set the background image of the workspace.</h4>
    <section id="defaultImages">
      <div>
        <img :src="bg[0]" alt="bg" @click="chBg(0)" />
        <img :src="bg[1]" alt="bg" @click="chBg(1)" /><img
          :src="bg[2]"
          alt="bg"
          @click="chBg(2)"
        />
      </div>
      <div>
        <img :src="bg[3]" alt="bg" @click="chBg(3)" />
        <img :src="bg[4]" alt="bg" @click="chBg(4)" /><img
          :src="bg[5]"
          alt="bg"
          @click="chBg(5)"
        />
      </div>
      <div>
        <img :src="bg[6]" alt="bg" @click="chBg(6)" />
        <img :src="bg[7]" alt="bg" @click="chBg(7)" /><img
          :src="bg[8]"
          alt="bg"
          @click="chBg(8)"
        />
      </div>
    </section>
    <section id="addAnotherImage">
      <input
        type="url"
        required
        v-model="bgValue"
        placeholder="Image URL:"
        @keyup.enter="chBg2"
      />
      <button @click="chBg2">Change</button>
    </section>
  </div>
</template>
<script>
export default {
  data() {
    return {
      bg: [
        "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b6/Image_created_with_a_mobile_phone.png/1200px-Image_created_with_a_mobile_phone.png",
        "https://p.bigstockphoto.com/GeFvQkBbSLaMdpKXF1Zv_bigstock-Aerial-View-Of-Blue-Lakes-And--227291596.jpg",
        "https://images.ctfassets.net/hrltx12pl8hq/4plHDVeTkWuFMihxQnzBSb/aea2f06d675c3d710d095306e377382f/shutterstock_554314555_copy.jpg",
        "https://images.unsplash.com/photo-1531160492875-2a09eb0cd73b?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1051&q=80",
        "https://images.unsplash.com/photo-1439405326854-014607f694d7?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1050&q=80",
        "https://images.unsplash.com/photo-1487466365202-1afdb86c764e?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1052&q=80",
        "https://images.unsplash.com/photo-1550399105-c4db5fb85c18?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1051&q=80",
        "https://images.unsplash.com/photo-1498837167922-ddd27525d352?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1050&q=80",
        "https://images.unsplash.com/photo-1451187580459-43490279c0fa?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1052&q=80",
      ],
      bgValue: "",
    };
  },
  methods: {
    chBg(index) {
      document.getElementsByTagName("main")[0].style.backgroundImage =
        "url(" + this.bg[index] + ")";
      this.$store.state.show = false;
    },
    chBg2() {
      if (this.bgValue.trim() === "") {
        alert("Please,fill the input!");
      } else if (
        !this.bgValue.includes("apng") &&
        !this.bgValue.includes("avif") &&
        !this.bgValue.includes("jpeg") &&
        !this.bgValue.includes("jfif") &&
        !this.bgValue.includes("pjpeg") &&
        !this.bgValue.includes("pjp") &&
        !this.bgValue.includes("png") &&
        !this.bgValue.includes("webp") &&
        !this.bgValue.includes("jpg") &&
        !this.bgValue.includes("gif") &&
        !this.bgValue.includes("svg")
      ) {
        alert("This format is not supported!");
        this.$store.state.show = false;
      } else {
        document.getElementsByTagName("main")[0].style.backgroundImage =
          "url(" + this.bgValue + ")";
        this.$store.state.show = false;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
#settings-wrapper {
  h4 {
    text-align: center;
    font-size: 26px;
    margin-bottom: 18px;
    @media screen and (max-width: 850px) {
      font-size: 24px;
    }
    @media screen and (max-width: 700px) {
      font-size: 20px;
    }
    @media screen and (max-width: 500px) {
      font-size: 18px;
      margin-top: 20px;
    }
    @media screen and (max-width: 430px) {
      font-size: 17px;
    }
    @media screen and (max-width: 390px) {
      font-size: 16px;
    }
    @media screen and (max-width: 370px) {
      font-size: 15px;
    }
    @media screen and (max-width: 346px) {
      font-size: 14.5px;
    }
  }
  #defaultImages {
    display: grid;
    grid-template-columns: auto auto auto;
    padding: 10px;
    margin: 0 auto;
    @media screen and (max-width: 624px) {
      justify-content: center;
    }
    div:nth-child(2) {
      @media screen and (max-width: 624px) {
        display: none;
      }
    }
    div:nth-child(3) {
      @media screen and (max-width: 500px) {
        display: none;
      }
    }
    div {
      margin: 0 auto;
      text-align: center;
      img {
        width: 250px;
        height: 150px;
        object-fit: cover;
        cursor: pointer;
        display: flex;
        margin: 8px;
        &:hover {
          opacity: 0.8;
        }
        @media screen and (max-width: 1154px) {
          width: 230px;
          height: 130px;
        }
        @media screen and (max-width: 850px) {
          width: 220px;
          height: 120px;
        }
        @media screen and (max-width: 800px) {
          width: 210px;
          height: 110px;
        }
        @media screen and (max-width: 725px) {
          width: 200px;
          height: 130px;
        }
        @media screen and (max-width: 700px) {
          width: 180px;
          height: 100px;
        }
        @media screen and (max-width: 624px) {
          width: 250px;
          height: 130px;
        }
        @media screen and (max-width: 560px) {
          width: 230px;
          height: 110px;
        }
        @media screen and (max-width: 500px) {
          width: 350px;
          height: 150px;
        }
        @media screen and (max-width: 430px) {
          width: 300px;
          height: 150px;
        }
        @media screen and (max-width: 370px) {
          width: 250px;
          height: 100px;
        }
      }
    }
  }
  #addAnotherImage {
    text-align: center;
    margin-bottom: 8px;
    input {
      height: 28px;
      width: 190px;
      color: darkblue;
      padding-left: 2px;
      font-weight: bold;
      display: inline;
      &::placeholder {
        margin-left: 4px;
        font-weight: normal;
      }
      &:focus {
        outline: none;
        border: 2px solid blue;
      }
    }
    button {
      height: 32px;
      color: #222222;
      background-color: yellow;
      border: 1.5px solid darkgreen;
      border-radius: 2px;
      font-weight: normal;
      display: inline;
      &:hover {
        opacity: 0.9;
      }
      &:active {
        box-shadow: 0 0 0.2vh darkcyan inset;
      }
    }
  }
}
</style>
